/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateCheckoutResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCreateCheckoutRequest, serializeCreateCheckoutResponse, type CreateCheckoutRequest, type CreateCheckoutResponse, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/subscriptions/checkout
 */
export interface CheckoutRequestBuilder extends BaseRequestBuilder<CheckoutRequestBuilder> {
    /**
     * Creates a Stripe Checkout Session in Elements UI mode (ui_mode: elements) for the chosen plans and returns its client secret, for the admin to initialise the Checkout Elements SDK with and render the Payment Element in its own checkout step. Prices are resolved from lookup keys server-side, so the caller never chooses what it is charged.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateCheckoutResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CreateCheckoutRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateCheckoutResponse | undefined>;
    /**
     * Creates a Stripe Checkout Session in Elements UI mode (ui_mode: elements) for the chosen plans and returns its client secret, for the admin to initialise the Checkout Elements SDK with and render the Payment Element in its own checkout step. Prices are resolved from lookup keys server-side, so the caller never chooses what it is charged.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateCheckoutRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CheckoutRequestBuilderUriTemplate = "{+baseurl}/api/organizations/subscriptions/checkout";
/**
 * Metadata for all the requests in the request builder.
 */
export const CheckoutRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CheckoutRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateCheckoutResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateCheckoutRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
